import React from 'react';
import { func, string, shape } from 'prop-types';
import { surveyJobMatch as surveyJobMatchPropType } from '../../propTypes';
import SurveyJobInformation from '../SurveyJobInformation/SurveyJobInformation';
import PayElementDropdown from '../../PayElementDropdown/PayElementDropdown';

import './SurveyJobMatchHeaders.scss';

class SurveyJobDrilldownHeader extends React.PureComponent {
  constructor(props) {
    super(props);

    this._onClick = this._onClick.bind(this);
  }

  static propTypes = {
    backAction: func,
    surveyJob: surveyJobMatchPropType,
    selectedPayElement: string,
    payElementLabels: shape({
      baseSalary: string,
      totalCash: string,
      totalTargetCash: string,
      totalDirect: string,
      totalGuaranteedPay: string
    }),
    selectPayElement: func
  };

  _onClick(e) {
    const { backAction } = this.props;
    e.preventDefault();
    backAction();
  }

  render() {
    const { surveyJob, selectedPayElement, payElementLabels, selectPayElement } = this.props;
    return (
      <div className="survey-job-matches__header survey-job-drilldown__header">
        <a className="survey-job-drilldown__back-btn" onClick={this._onClick}>
          <i className="icon-reply" />
          Return to all matches
        </a>
        <SurveyJobInformation metadata={surveyJob.metadata} />
        <PayElementDropdown
          selectedPayElement={selectedPayElement}
          payElements={payElementLabels}
          onElementClick={selectPayElement}
          label={'Pay Elements'}
        />
      </div>
    );
  }
}

export default SurveyJobDrilldownHeader;
